/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SaveOrganicTrafficConfigOptions,
  SaveOrganicTrafficConfigResponses,
} from '../types/SaveOrganicTrafficConfig'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Replaces the whole configuration: every field is required, and a field left out is rejected rather than left at its stored value. The bot service re-reads the configuration every time it scores the book, so a change takes effect on the next score rather than on the next deploy.
 * @summary Replace an order book's organic activity score configuration
 * {@link /v1/bots/organic-traffic/config/:order_book_id}
 */
export function saveOrganicTrafficConfig<ThrowOnError extends boolean = true>(
  options: Options<SaveOrganicTrafficConfigOptions, ThrowOnError>,
): Unwrappable<RequestResult<SaveOrganicTrafficConfigResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/bots/organic-traffic/config/{order_book_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SaveOrganicTrafficConfigResponses, ThrowOnError>>,
  )
}
